"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleRoutes = void 0;
var RoleRoutes;
(function (RoleRoutes) {
    RoleRoutes["BasePrefix"] = "roles";
    RoleRoutes["ById"] = ":roleId";
    RoleRoutes["All"] = "all";
    RoleRoutes["List"] = "list";
})(RoleRoutes = exports.RoleRoutes || (exports.RoleRoutes = {}));
